import html from "./FormStep.html"
import { getDefaultSurveyQuestionResult } from "../../../components/Survey/Util/getDefaultSurveyQuestionResult";
import "../SurveyReactComponent"
import * as surveyResultHelper from "../../../helpers/surveyResultHelper"

var module = angular.module("ResearchKitApplicationModule");

module.directive("formStep",
	function () {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "="
			}
		};
	}
);

module.controller("formStepController", ["$scope",
	function ($scope) {
		$scope.resultChanged = function (result) {
			$scope.stepManager.setChildResult(result.Identifier, result);
			$scope.stepManager.resultDidChange();
			if (!$scope.$$phase && !$scope.$root.$$phase) {
				$scope.$apply();
			}
		}

		$scope.submitForm = function () {
			$scope.$apply(function () {
				$scope.stepManager.continue();
			});
		}

		let formProps = null;
		$scope.getFormProps = function () {
			var newFormProps = {
				key: $scope.stepManager.step.identifier,
				formItems: $scope.stepManager.getFormItems(),
				results: [...$scope.stepManager.childResults],
				onResultChange: $scope.resultChanged,
				onEnterPressed: $scope.submitForm,
				variant: $scope.stepManager.getFormStyle()
			};
			if (!angular.equals(newFormProps, formProps)) {
				formProps = newFormProps;
			}
			return formProps;
		}
	}
]);

module.factory("FormStepManager", ["StepManager", "predicateEvaluator", function (StepManager, predicateEvaluator) {
	function FormStepManager(step, surveyManager) {
		StepManager.call(this, step, surveyManager);
	}
	FormStepManager.prototype = Object.create(StepManager.prototype);

	FormStepManager.prototype.initializeResults = function (previousResult) {
		for (var i = 0; i < this.step.formItems.length; i++) {
			var identifier = this.step.formItems[i].identifier;
			var previousQuestionResult = previousResult ? previousResult.QuestionResults.find(r => r.Identifier.toLowerCase() === identifier.toLowerCase()) : null;
			var restoredQuestionResult = {
				...previousQuestionResult,
				Identifier: identifier,
				Type: this.step.formItems[i].answerFormat?.type === "FileAnswerFormat" ? "FileResult" : "QuestionResult",
				StartDate: this.presentedDate,
				EndDate: undefined
			};

			let defaultSurveyResult = getDefaultSurveyQuestionResult(this.step.formItems[i].identifier, this.step.formItems[i].answerFormat);
			if (!restoredQuestionResult.Answer && defaultSurveyResult.Answer !== undefined) {
				restoredQuestionResult.Answer = defaultSurveyResult.Answer;
			}
			if (!restoredQuestionResult.Choices && defaultSurveyResult.Choices !== undefined) {
				restoredQuestionResult.Choices = defaultSurveyResult.Choices;
			}

			this.childResults.push(restoredQuestionResult);
		}
		this.resultDidChange();
	};

	FormStepManager.prototype.continueDisabled = function () {
		var base = this;

		function answerIsInvalid(formItem) {
			var result = base.getChildResult(formItem.identifier);

			if (!result) return false;

			return result.invalid;
		}

		let anyAnsweredQuestions = false;
		let anyVisibleQuestions = false;
		let visibleFormItems = this.step.formItems.filter(f => !base.hideFormItem(f));
		for (var i = 0; i < visibleFormItems.length; i++) {
			let item = visibleFormItems[i];
			if (answerIsInvalid(item)) {
				return true;
			}

			const result = base.getChildResult(item.identifier);
			const resultHasAnswer = item.answerFormat && surveyResultHelper.hasAnswer(result);
			if (resultHasAnswer) {
				anyAnsweredQuestions = true;
			} else if (item.answerFormat && !item.optional ) {
				return true; //early return because we found an unanswered required question
			}

			if (item.answerFormat) {
				anyVisibleQuestions = true;
			}
		}

		return !anyAnsweredQuestions && anyVisibleQuestions;
		
	};
	FormStepManager.prototype.canContinue = function () {
		return !this.continueDisabled() || this.step.optional !== false;
	};

	FormStepManager.prototype.setResultHiddenState = function (item, hidden) {
		var childResult = this.getChildResult(item.identifier);
		if (hidden) {
			childResult.hidden = true;
		}
		else {
			delete childResult.hidden;
		}
	}

	FormStepManager.prototype.hideFormItem = function (item) {
		if (!item.hidePredicate || this.surveyManager.editMode) return false;

		var activeManagedResults = this.surveyManager.getActiveManagedResults();
		var hideItem = predicateEvaluator.evaluatePredicate(item.hidePredicate, activeManagedResults);
		this.setResultHiddenState(item, hideItem);
		return hideItem;
	}

	FormStepManager.prototype.getFormItems = function () {
		return this.step.formItems.filter(s => !this.hideFormItem(s));
	};

	return FormStepManager;
}]);